import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  LiveFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";
import { AddPrice } from '../../screens/LivePrices/components';

import { Header, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const Livepriceummary = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const [isadd, setIsadd] = useState(false);
  const [liveobj, setLiveobj] = useState({});
  const snackbarCtx = React.useContext(SnackBarContext);
  const [ispreparedownload, setIspreparedownload] = useState(false);
  const [downloaddata, setDownloaddata] = useState([]);
  useEffect(() => {
     var product_id = props.location.pathname.split('/')[2];

     fetchallprices(product_id)

  
  }, []);


  async function updateprice(liveobj)
  {
    let adminusers = await sendNetworkRequest('/updateliverate', {}, liveobj,false)
    setIsadd(false)
    fetchallprices()
  }
  async function dismiss()
  {

    setIsadd(false)
  }
  function addprice(priceobj)
  {
    setLiveobj({
      ...liveobj,
      productID : priceobj.productID,
      pricefrom : priceobj.rangestart,
      priceto : priceobj.rangeend,
    })
    setIsadd(true)
  }
  function editprice(priceobj)
  {
    setLiveobj({
      ...liveobj,
      liverateID : priceobj.liverateID,
      productID : priceobj.productID,
      pricefrom : priceobj.rangestart,
      priceto : priceobj.rangeend,
      isRange : priceobj.rangeend > 0 ? true : false,
      price_diff : priceobj.price_diff
    })
    setIsadd(true)
  }
  function onSearch(key, value)
  {
    fetchallprices(value)
  }
 async function onDelete(priceobj)
  {
    let adminusers = await sendNetworkRequest('/deleteliverate', {}, {liverateID : priceobj.liverateID},false)
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: "success",
      msg: adminusers.message,
      vertical: "top",
    });
  let val =props.location.pathname.split('/')[2];
    fetchallprices(val) 
  }

  async function downloadPriceSummary()
  {
    let val =props.location.pathname.split('/')[2];
    let bodycontent = {
      product_id : val
    }
    let adminusers = await sendNetworkRequest('/admin/fetchproductpricehistory', {}, bodycontent,false)
    console.log(adminusers)
    setIspreparedownload(true)
    setDownloaddata(adminusers.pricehistory)




    
  }
  async function updateprice(liveobj)
  {
    let adminusers = await sendNetworkRequest('/updateliverate', {}, liveobj,false)
    setIsadd(false)
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: "success",
      msg: adminusers.message,
      vertical: "top",
    });
    let val =props.location.pathname.split('/')[2];

    fetchallprices(val)
  }
  async function fetchallprices(value)
  {
    let bodycontent = {
      product_id : value
    }
   
    let adminusers = await sendNetworkRequest('/admin/viewprice', {}, bodycontent,false)
    setOrders(adminusers.module)
  }
  return (
    <Page
      className={classes.root}
      title="Live Prices"
    >
      <Header  downloadPriceSummary={downloadPriceSummary} isdownloadready={ispreparedownload} data={downloaddata} />
      {isadd ? <AddPrice onUpdate={updateprice}  onDismiss={dismiss} liveobj={liveobj}/> : null }

      
      <Results
        className={classes.results}
        onDelete={onDelete}
        orders={orders} //
        onAdd={addprice}
        onEdit={editprice}
      />
     
    </Page>
  );
});

export default Livepriceummary;
